import React from 'react';
import classes from './Navbar.module.css';
import cn from 'classnames';
import AppComponentContext from '../../../contexts/AppComponentContext';

const navbar = (props) => {
  const headerCss = props.round ? [classes.Navbar, classes.Round].join(' ') : classes.Navbar;
  const centerCss = props.backNavbar ? { flex: 6 } : null;

  return (
    <AppComponentContext.Consumer>
      {appContext => (
        <div
          className={cn(
          classes.NavbarWrapper,
          {
            [classes.NavbarWrapperLandscapeLanding]: !appContext.loggedIn && appContext.isLandscape,
            [classes.FromLandscapeModal]: (props.fromModal && appContext.isLandscape)
          }
        )}
          style={Object.assign((appContext.isLandscape && !props.fromModal) ? {width: appContext.centralWidth} : {}, props.navbarCustomWrapperStyles)}

        >
          <header className={headerCss} style={props.style}>
            <nav className={classes.LeftNav}>
              {props.left}
            </nav>
            <nav className={classes.CenterNav} style={centerCss}>
              {props.center}
            </nav>
            <nav className={classes.RightNav}>
              {props.right}
            </nav>
          </header>
        </div>
      )}
    </AppComponentContext.Consumer>
  );
};

export default navbar;
